export enum ManualTrackingEnum {
  MANUAL = "manualTracking",
  AUTOMATIC = "automaticTracking",
}
